// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27XIR","rootMobile":"styles_rootMobile__GLJxm"};